// Chakra imports
import {
  SimpleGrid,
  Text,
  useColorModeValue,
  FormControl,
  FormLabel,
  Input,
  Button,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import { useState } from "react";
import { useForm } from "react-hook-form";

export default function InfoUser(props: { [x: string]: any }) {
  const { ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [isLoading, setIsLoding] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { register, handleSubmit } = useForm();

  const submitUpdateInfoUser = (data: any) => {
    setErrorMessage("");
    setIsLoding(true);

    if (data.passwordInfoUser !== data.repeatPasswordInfoUser) {
      setErrorMessage("As senha são diferentes");
      setIsLoding(false);
    }
  };

  return (
    <Card key="InfoUser" mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Informações do usuário
      </Text>

      <form onSubmit={handleSubmit(submitUpdateInfoUser)}>
        <Text
          mb="12px"
          ms="4px"
          color="red.500"
          fontWeight="400"
          fontSize="md"
          textAlign="center"
        >
          {errorMessage}
        </Text>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} gap="20px" mb="20px">
          <FormControl>
            <FormLabel>Usuario</FormLabel>
            <Input
              id="userInfoUser"
              type="text"
              color={textColorPrimary}
              defaultValue={localStorage.getItem("username")}
              {...register("userInfoUser")}
              required
            />
          </FormControl>

          <FormControl>
            <FormLabel>Email</FormLabel>
            <Input
              id="emailInfoUser"
              type="email"
              color={textColorPrimary}
              {...register("emailInfoUser")}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Senha</FormLabel>
            <Input
              id="passwordInfoUser"
              type="password"
              color={textColorPrimary}
              {...register("passwordInfoUser")}
              required
            />
          </FormControl>

          <FormControl>
            <FormLabel>Repita a senha</FormLabel>
            <Input
              id="repeatPasswordInfoUser"
              type="password"
              color={textColorPrimary}
              {...register("repeatPasswordInfoUser")}
              required
            />
          </FormControl>
        </SimpleGrid>
        <Button
          type="submit"
          fontSize="sm"
          variant="brand"
          fontWeight="500"
          w="10%"
          h="50"
          mb="24px"
          isLoading={isLoading}
        >
          Salvar
        </Button>
      </form>

      {/* <Project
				boxShadow={cardShadow}
				mb='20px'
				image={Project1}
				ranking='1'
				link='#'
				title='Technology behind the Blockchain'
			/>
			<Project
				boxShadow={cardShadow}
				mb='20px'
				image={Project2}
				ranking='2'
				link='#'
				title='Greatest way to a good Economy'
			/>
			<Project
				boxShadow={cardShadow}
				image={Project3}
				ranking='3'
				link='#'
				title='Most essential tips for Burnout'
			/> */}
    </Card>
  );
}
